
import { defineComponent } from 'vue'

// page information
interface PageInfo {
  [lang: string]: {
    [name: string]: {
      url: string,
      title: string,
      active: boolean
    }
  }
}

// image information
interface ImageInfo {
  src: string,
  text: string,
  active: boolean
}

// language information
interface LangInfo {
  [lang: string]: {
    text: string,
    url: string
  }
}

const App = defineComponent({
  data () {
    return {
      activelang: 'ja',
      pages: {
        ja: {
          top: { url: '/', title: 'トップ', active: true },
          cv: { url: '/cv', title: '略歴', active: false },
          publication: { url: '/publication', title: '出版物', active: false },
          presentation: { url: '/presentation', title: '発表・講演', active: false },
          note: { url: '/note', title: 'ノート', active: false },
          link: { url: '/link', title: 'リンク', active: false }
        },
        en: {
          top: { url: '/top_en', title: 'Top', active: false },
          cv: { url: '/cv_en', title: 'CV', active: false },
          publication: { url: '/publication_en', title: 'Publications', active: false },
          presentation: { url: '/presentation_en', title: 'Presentations', active: false },
          link: { url: '/link_en', title: 'Links', active: false }
        }
      } as PageInfo,
      imageInfos: [
        {
          src: require('@/assets/header/header_01.jpg'),
          text: '青森・奥入瀬渓流',
          active: true
        },
        {
          src: require('@/assets/header/header_02.jpg'),
          text: 'ジュネーブ・サンピエール大聖堂より',
          active: false
        },
        {
          src: require('@/assets/header/header_03.jpg'),
          text: 'ジュネーブ・ローヌ川付近の夜景',
          active: false
        }
      ] as ImageInfo[],
      langInfos: {
        ja: { text: '日本語', url: '/' },
        en: { text: 'English', url: '/top_en' }
      } as LangInfo
    }
  },

  methods: {
    // set the active page
    setActive (pageName: string) {
      if (this.$route.path.endsWith('_en')) {
        this.activelang = 'en'
      } else {
        this.activelang = 'ja'
      }
      for (const key in this.pages[this.activelang]) {
        this.pages[this.activelang][key].active = (key === pageName)
      }
    }
  }
})
export default App
